
/* eslint-disable no-magic-numbers */
// 合同常量

// SRM_CONTRACT_STATUS 合同状态
export const APPEND = '10'; // 新增
export const IN_APPROVAL = '20'; // 审批中
export const STAMP = '30'; // 待盖章
export const FILEDDING = '40'; // 归档中
export const FILED = '50'; // 已归档
export const EFFECT = '60'; // 生效
export const DRAFT = '99'; // 草稿
export const ABANDON = '70'; // 废弃
export const TERMINATION = '80'; // 终止

// SYS_BMS_NEW_MIP_STATUS mip流程状态
export const MIP_STATUS = {
    DRAFT: '00', // 草稿
    SUBMIT: '10', // 提交
    ADOPT: '20', // 通过
    REJECT: '30', // 驳回
    ABANDONMENT: '40', // 废弃
    WITHDRAW: '80', // 撤回
    PROCESSING: '90', // 处理中
    OTHER: '100' // 其他
};

// SRM_CONTRACT_SOURCE 合同来源
export const BIDING = '2'; // 招标

// 合同操作类型
export const STATE_VIEW = 'view'; // 查看：非草稿、新增状态的主合同和子合同
export const STATE_MAIN = 'main'; // 主合同：草稿、新增状态的主合同
export const STATE_STOP = 'stop'; // 终止：草稿、新增状态的子合同
export const STATE_CHANGE = 'change'; // 变更：草稿、新增状态的子合同
export const STATE_OTHER_CHANGE = 'other-change'; // 其他变更：草稿、新增状态的子合同
export const STATE_PRICE_CHANGE = 'price-change'; // 价格表变更：草稿、新增状态的子合同
export const STATE_NEW = 'new'; // 新增：刚新增的主合同

// 合同申请类型 SRM_CONTRACT_APPLY_TYPE
export const APPLY_TYPES_MAIN = '1'; // 主合同
export const APPLY_TYPES_CHANGE = '2'; // 合同变更
export const APPLY_TYPES_OTHER_CHANGE = '3'; // 合同其他变更
export const APPLY_TYPES_STOP = '4'; // 合同终止
export const APPLY_TYPES_PRICE_CHANGE = '5'; // 价格表变更

// SRM_CONTRACT_TYPE_ALL 合同类型
export const PRESIGN = '3'; // 预签合同
export const FORMAL = '1'; // 正式合同

// SRM_CONTRACT_WH_NEW_RENEWAL 新签/续签-仓储
export const NEW_BUSINESS = '1'; // 新业务/新仓

// SRM_CONTRACT_OTHER_NEW_RENEWAL 新签\续签-非仓储
export const NEW_SIGN = '10'; // 新签或新业务
export const OLD_BUSINESS_ORIGIN_SUPPLIER = '20'; // 新/续签--老业务原供方
export const OLD_BUSINESS_NEW_SUPPLIER = '30'; // 新/续签--老业务新供方

// SRM_NO_LOGISTICS_CONTRACT_TYPE 合同类型（非物流）
export const CONTRACT_DEVICE_TYPE = '2'; // 设备类

// SRM_BUSYNESS_TYPE_NO_LOGISTICS 业务类型（非物流）
export const DEVICE_TYPE = '11'; // 设备类

// SRM_CONTRACT_BUSINESS_CATEGORY 业务分类
export const DEVICE_LEASE = '8'; // 设备租赁
export const DEVICE_PURCHASE = '9'; // 设备采购
export const ZC_LD_SUPPLIER = '27'; // 基地整车/零担专线供应商

// SRM_LEASED_ASSETS_TYPE 租赁资产类型
export const HOUSE_BUILDING = '1'; // 房屋建筑物
export const ELECTRONIC_DEVICE = '5'; // 电子设备

// SRM_DEVICE_TYPE 设备类型
export const FORK_LIFT = '1'; // 叉车
export const TRAY = '2'; // 托盘

// 是否多规则
export const MORE_RULE_YES = 1;

// SRM_EQUIPMENT_LEASING_STATUS
export const EL_STATUS = {
    ADD: '1', // 新增
    TL: '2', // 退租
    UPDATE: '3', // 信息更新
    PART_TL: '4', // 部分退租
};

// SRM_CONTRACT_PROCUREMENT_TYPE 采购方式
export const PUB_BID = '1'; // 公开招标
export const INV_BID = '2'; // 邀请招标(一对多线上竞价)
export const SPECIFIED_SUP = '4'; // 客户指定下游供应商
export const PRE_COOPERATE = '6'; // 联合投标

// SRM_CONTRACT_SOURCE 合同来源
export const SRC_BID = '2'; // 招标
